







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import AnalysisTriggerList from '@/components/analysis-triggers/analysis-trigger-list.vue';

@Component({
  components: {
    AnalysisTriggerList,
    PageTitle
  }
})
export default class AnalysisTriggers extends Vue {}
